import React from 'react';
import * as RadixDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import './Dialog.css';

export interface DialogProps {
  returnFocusRef?: React.RefObject<HTMLElement | null>;
  className?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: React.ReactNode;
}

export const Dialog: React.FC<DialogProps> = ({
  returnFocusRef,
  className = '',
  open,
  onOpenChange,
  title,
  description,
  children,
}) => {
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="sedlex-dialog-overlay" />
        <RadixDialog.Content
          className={`sedlex-dialog-content ${className}`}
          onCloseAutoFocus={
            returnFocusRef
              ? (event) => {
                  event.preventDefault();
                  returnFocusRef.current?.focus();
                }
              : undefined
          }
        >
          <div className="sedlex-dialog-header">
            <RadixDialog.Title className="sedlex-dialog-title">{title}</RadixDialog.Title>
            {description && (
              <RadixDialog.Description className="sedlex-dialog-desc">
                {description}
              </RadixDialog.Description>
            )}
            <RadixDialog.Close className="sedlex-dialog-close" aria-label="Close">
              <X aria-hidden="true" />
            </RadixDialog.Close>
          </div>
          <div className="sedlex-dialog-body">{children}</div>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
};
